module.exports = __webpack_public_path__ + "static/media/sobhaLogo.fdcc5f62.png";